module.exports = __webpack_public_path__ + "static/media/mail.53c05f0e.svg";